import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./components/ThemeProvider";
import { LanguageProvider } from "./components/LanguageProvider";
import { AuthProvider } from "./components/AuthProvider";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import { AppLayout } from "./components/layout/AppLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import OntologyBuilder from "./pages/OntologyBuilder";
import GraphExplorer from "./pages/GraphExplorer";
import GISMapView from "./pages/GISMapView";
import TimelineAnalytics from "./pages/TimelineAnalytics";
import SearchResults from "./pages/SearchResults";
import WorksheetBuilder from "./pages/WorksheetBuilder";
import AlertsReports from "./pages/AlertsReports";
import AdminSettings from "./pages/AdminSettings";
import DesignSystem from "./pages/DesignSystem";
import Downloads from "./pages/Downloads";
import "./App.css";

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="palantir-ui-theme">
      <LanguageProvider>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              {/* Public Route - Login */}
              <Route path="/login" element={<Login />} />
              
              {/* Protected Routes */}
              <Route element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }>
                <Route path="/" element={<Dashboard />} />
                <Route path="/ontology" element={<OntologyBuilder />} />
                <Route path="/graph" element={<GraphExplorer />} />
                <Route path="/map" element={<GISMapView />} />
                <Route path="/timeline" element={<TimelineAnalytics />} />
                <Route path="/search" element={<SearchResults />} />
                <Route path="/worksheet" element={<WorksheetBuilder />} />
                <Route path="/alerts" element={<AlertsReports />} />
                <Route path="/admin" element={<AdminSettings />} />
                <Route path="/design-system" element={<DesignSystem />} />
                <Route path="/downloads" element={<Downloads />} />
              </Route>
            </Routes>
          </AuthProvider>
        </BrowserRouter>
        <Toaster position="top-right" />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
